module.exports = __webpack_public_path__ + "img/t1.707360d3.png";